import React, { useRef, useState } from "react";
import { } from "../../../redux/slices/articulosSlice";
import { ReactComponent as AudiIcon } from "../../../assets/images/logo.svg";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";

import ROUTES from "../../../utils/routes";

import { Search, Menu, Close, ArrowLeft } from "../../Icons";

import { encodeNumber as nToString } from "../../../API/request";

import { LazyLoadImage } from "react-lazy-load-image-component";

const Header = ({ showHeader, actual = "", showBtnBack, listado = [] }) => {
  const location = useLocation();
  const articulos = useSelector((state) => state.articulos.articulos);

  const ref = useRef(null);
  const refSearchContainer = useRef(null);
  const refSearchOverlayContainer = useRef(null);

  const [searchActive, setSearchActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [search, setSearch] = useState("");

  const [resultados, setResultados] = useState([]);

  let history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  const handleSearch = (e) => {
    const value = e.target.value;

    if (value && value.length > 0) {
      setSearchActive(true);
      setSearch(value);

      const filter = articulos.filter((articulo) => {
        const nombreEnMinusculas = articulo.nombre.toLowerCase();
        return nombreEnMinusculas.includes(value.toLowerCase());
      });

      setResultados(filter.slice(0, 5));

      refSearchContainer.current.classList.add("active");
      refSearchOverlayContainer.current.classList.add("active");
    } else {
      setSearchActive(false);
      setResultados([]);
      setSearch("");
      refSearchContainer.current.classList.remove("active");
      refSearchOverlayContainer.current.classList.remove("active");
    }
  };

  const getImage = (originalImgUrl) => {
    const imageCategory = originalImgUrl.replace(".png", "-category.png");

    return process.env.REACT_APP_IMAGE_PATH + imageCategory;
  };

  return (
    <>
      <header>
        <div className="d-flex w-100">
          <Link to={ROUTES.HOME}>
            <AudiIcon />
          </Link>
          <h2 className="ms-3">Audi Accesorios</h2>
          <div className="navigation d-none d-lg-block ">
            {location.pathname !== ROUTES.HOME && (
              <Link to={ROUTES.HOME}>Modelos</Link>
            )}
          </div>
          <label className="in-label d-none d-lg-block">
            <div className="in-label-icon">
              <Search />
            </div>

            <input
              ref={ref}
              className="in-general in-search"
              type="text"
              placeholder="Búsqueda"
              onKeyUp={handleSearch}
            />
          </label>
        </div>
      </header>
      <div ref={refSearchContainer} className="w-100 containerSearchNav">
        <div className="searchHeader">
          {showBtnBack && !menuActive && !searchActive && (
            <div className="col-10">
              <button
                className="btn-general btn-tertiary-prev black v-align-c mt-0"
                onClick={goBack}
              >
                <ArrowLeft />
                <span>Volver</span>
              </button>
            </div>
          )}

          {!searchActive && menuActive && (
            <div
              onClick={() => {
                setSearchActive(true);
                setMenuActive(false);
              }}
            >
              <Search />
            </div>
          )}
          {searchActive && (
            <label className="in-label">
              <div className="in-label-icon">
                <Search />
              </div>

              <input
                ref={ref}
                className="in-general in-search"
                type="text"
                placeholder="Búsqueda"
                onKeyUp={handleSearch}
              />
            </label>
          )}

          {menuActive || searchActive ? (
            <div
              onClick={() => {
                setMenuActive(!menuActive);
                setSearchActive(false);
                refSearchContainer.current.classList.remove("active");
                refSearchOverlayContainer.current.classList.remove("active");
              }}
            >
              <Close />
            </div>
          ) : (
            <div
              onClick={() => setMenuActive(!menuActive)}
              style={{ marginLeft: "auto", transform: "scaleX(-1)" }}
            >
              <Menu />
            </div>
          )}
        </div>
        <div
          className={`navigation-links mt-4 mb-2 ${menuActive ? "d-block" : "d-none"
            }`}
        >
          <Link to={ROUTES.HOME}>Modelos</Link>
        </div>
        <div className={searchActive ? "d-block" : "d-none"}>
          <ul className="w-100">
            {resultados.length > 0 ? (
              resultados.map((articulo) => {
                return (
                  <li key={articulo.id}>
                    <Link to={ROUTES.DETAILSEMPTY + nToString(articulo.id)}>
                      {articulo.nombre}
                    </Link>
                  </li>
                );
              })
            ) : (
              <p>No se encontraron resultados</p>
            )}
          </ul>

          {resultados.length > 0 && (
            <div className="mt-5">
              <Link to={ROUTES.RESULTS + "/" + search}>
                Mostrar todos los resultados {`>`}{" "}
              </Link>
            </div>
          )}
        </div>
      </div>

      {showHeader && (
        <div className="collectionDetails--new">
          <div className="collectionDetails_mobile--collection">
            <div className="collectionDetails--new--info">
              <button
                className="btn-general btn-tertiary-prev v-align-c"
                onClick={goBack}
              >
                <ArrowLeft />
                <span>Volver</span>
              </button>
              <h4>{actual}</h4>
            </div>
            <div className="collectionDetails--new--image">
              {listado.map(
                (item, i) =>
                  item.nombre === actual && (
                    <LazyLoadImage
                      alt={item.img}
                      src={getImage(item.img)}
                      key={"imgMClist_" + i}
                    />
                  )
              )}
            </div>
          </div>
        </div>
      )}

      <div
        ref={refSearchOverlayContainer}
        className="w-100 containerSearchNav-overlay"
      ></div>
    </>
  );
};

export default Header;
